module.exports = __webpack_public_path__ + "img/ico-gastric-cancer-90-x-90.2dd24d46.svg";